'use strict';

const variantPriorityOrder = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit",
];
const variantProps = ["initial", ...variantPriorityOrder];

exports.variantPriorityOrder = variantPriorityOrder;
exports.variantProps = variantProps;
//# sourceMappingURL=variant-props.cjs.map
